// ============================================================
// VCS.ChatRecordingUI — Record-Button, Recording-Bar, Popup
// ============================================================
window.VCS = window.VCS || {};

VCS.ChatRecordingUI = class {

    // ── Konstanten ───────────────────────────────────────────

    static CHAT_RECORD_ARM_MS = 2200;
    static CHAT_RECORD_MAX_MS = 60 * 1000;

    // ── Konstruktor ──────────────────────────────────────────

    constructor() {
        this._view = {};
    }

    // ── Öffentliche Methoden ─────────────────────────────────

    getRecordModeLabel(mode) {
        const m = mode !== undefined ? mode : VCS.state.chatRecordMode;
        return m === 'video' ? (t('chatVideo') || 'Video') : (t('chatVoiceMessage') || 'Voice');
    }

    updateRecordingBarMode() {
        const modeEl = $('#chatRecordingMode')[0];
        if (modeEl) {
            modeEl.textContent = this.getRecordModeLabel();
        }
        $('#chatRecordingBar')[0]?.classList.toggle('chat-recording-bar--video', VCS.state.chatRecordMode === 'video');
    }

    updateRecordButtonUI() {
        const btn = $('#chatMicBtn')[0];
        if (!btn) {
            return;
        }
        VCS.ui?.setButtonIcon?.('chatMicBtn', VCS.state.chatRecordMode === 'video' ? 'chatCam' : 'chatMic');
        btn.dataset.recordMode = VCS.state.chatRecordMode;
        btn.classList.toggle('chat-mic-btn--mode-video', VCS.state.chatRecordMode === 'video');
        btn.title = VCS.state.chatRecordMode === 'video' ? 'Videoaufnahme' : t('tooltipVoice');
    }

    clearRecordTimers() {
        if (VCS.state.chatRecordingTimerInterval) {
            clearInterval(VCS.state.chatRecordingTimerInterval);
            VCS.state.chatRecordingTimerInterval = null;
        }
        if (VCS.state.chatRecordingSendInterval) {
            clearInterval(VCS.state.chatRecordingSendInterval);
            VCS.state.chatRecordingSendInterval = null;
        }
        if (VCS.state.chatRecordingLimitTimer) {
            clearTimeout(VCS.state.chatRecordingLimitTimer);
            VCS.state.chatRecordingLimitTimer = null;
        }
    }

    disarmRecordButton() {
        if (VCS.state.chatRecordArmTimer) {
            clearTimeout(VCS.state.chatRecordArmTimer);
            VCS.state.chatRecordArmTimer = null;
        }
        VCS.state.chatRecordArmed = false;
        $('#chatMicBtn')[0]?.classList.remove('chat-mic-btn--armed');
    }

    armRecordButton() {
        this.disarmRecordButton();
        VCS.state.chatRecordArmed = true;
        $('#chatMicBtn')[0]?.classList.add('chat-mic-btn--armed');
        VCS.state.chatRecordArmTimer = setTimeout(() => {
            this.disarmRecordButton();
        }, VCS.ChatRecordingUI.CHAT_RECORD_ARM_MS);
    }

    clearHoldTimer() {
        if (VCS.state.chatRecordHoldTimer) {
            clearTimeout(VCS.state.chatRecordHoldTimer);
            VCS.state.chatRecordHoldTimer = null;
        }
    }

    setRecordMode(mode) {
        if (mode !== 'voice' && mode !== 'video') {
            return;
        }
        VCS.state.chatRecordMode = mode;
        localStorage.setItem('chat-record-mode', mode);
        this.updateRecordButtonUI();
        this.updateRecordingBarMode();
    }

    toggleRecordMode() {
        if (VCS.state.chatRecording) {
            return;
        }
        this.setRecordMode(VCS.state.chatRecordMode === 'voice' ? 'video' : 'voice');
        VCS.ui?.showToast?.(
            VCS.state.chatRecordMode === 'video' ? t('recordModeVideoActive') : t('recordModeVoiceActive'),
            'info',
            1500
        );
    }

    handlePointerDown() {
        // nicht mehr benötigt
    }

    handlePointerUp() {
        // nicht mehr benötigt
    }

    handleClick() {
        if (VCS.state.chatRecording) {
            VCS.chatMessages?.stopRecording?.();
            this.hideRecordPopup();
            return;
        }
        // Bot-Chat: kein Popup, nur Voice (Video/Sprachfoto sind backend-blockiert).
        if (VCS.Chat?.isBotChat?.(VCS.state.chatActiveChatId)) {
            this.setRecordMode('voice');
            VCS.chatMessages?.startRecording?.();
            return;
        }
        const popup = $('#chatRecordPopup')[0];
        if (popup && !popup.classList.contains('hidden')) {
            this.hideRecordPopup();
            return;
        }
        this.showRecordPopup();
    }

    showRecordPopup() {
        let popup = $('#chatRecordPopup')[0];
        if (!popup) {
            popup = document.createElement('div');
            popup.id = 'chatRecordPopup';
            popup.className = 'chat-record-popup';
            popup.innerHTML = `
            <button type="button" class="chat-record-popup-btn" data-mode="voice">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                    <path d="M12 1a4 4 0 0 0-4 4v6a4 4 0 0 0 8 0V5a4 4 0 0 0-4-4z"></path>
                    <path d="M19 10a1 1 0 0 0-2 0 5 5 0 0 1-10 0 1 1 0 0 0-2 0 7 7 0 0 0 6 6.93V20a1 1 0 0 0 2 0v-3.07A7 7 0 0 0 19 10z"></path>
                </svg>
                <span data-i18n="chatVoiceMessage">${escapeHtml(t('chatVoiceMessage') || 'Sprache')}</span>
            </button>
            <button type="button" class="chat-record-popup-btn" data-mode="video">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polygon points="23 7 16 12 23 17 23 7"></polygon>
                    <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
                </svg>
                <span data-i18n="chatVideo">${escapeHtml(t('chatVideo') || 'Video')}</span>
            </button>
            <button type="button" class="chat-record-popup-btn" data-mode="photo">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                    <path d="M9.5 4l-1.2 1.6A2 2 0 0 1 6.7 6.5H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2h-2.7a2 2 0 0 1-1.6-.9L14.5 4h-5z"/>
                    <circle cx="12" cy="13" r="3.5" fill="var(--bg-elevated-2, #1a1a1a)"/>
                </svg>
                <span data-i18n="chatPhoto">${escapeHtml(t('chatPhoto'))}</span>
            </button>`;
            $('#chatMicBtn')[0]?.parentElement?.appendChild(popup);
            popup.addEventListener('click', (e) => {
                const btn = e.target.closest('.chat-record-popup-btn');
                if (!btn) return;
                const mode = btn.dataset.mode;
                this.hideRecordPopup();
                if (mode === 'photo') {
                    VCS.chatPhoto?.capturePhoto?.();
                    return;
                }
                this.setRecordMode(mode);
                VCS.chatMessages?.startRecording?.();
            });
        }
        popup.classList.remove('hidden');
        setTimeout(() => {
            document.addEventListener('pointerdown', this._popupOutsideHandler);
        }, 0);
    }

    hideRecordPopup() {
        $('#chatRecordPopup')[0]?.classList.add('hidden');
        document.removeEventListener('pointerdown', this._popupOutsideHandler);
    }

    recordPopupOutside(e) {
        const popup = $('#chatRecordPopup')[0];
        const btn = $('#chatMicBtn')[0];
        if (popup && !popup.contains(e.target) && btn && !btn.contains(e.target)) {
            this.hideRecordPopup();
        }
    }

    startRecordingUi() {
        VCS.state.chatRecordStart = Date.now();
        VCS.state.chatRecording = true;
        $('#chatMicBtn')[0]?.classList.add('chat-mic-btn--recording');
        this.updateRecordingBarMode();
        $('#chatRecordingBar')[0]?.classList.remove('hidden');
        const timeEl = $('#chatRecordingTime')[0];
        if (timeEl) {
            timeEl.textContent = '0:00';
        }

        if (VCS.state.chatActiveChatId) {
            VCS.chat?.wsSend?.({
                type  : 'chat-recording',
                chatId: VCS.state.chatActiveChatId,
                phone : VCS.state.chatMyPhone
            });
            VCS.state.chatRecordingSendInterval = setInterval(() => {
                if (VCS.state.chatRecording && VCS.state.chatActiveChatId) {
                    VCS.chat?.wsSend?.({
                        type  : 'chat-recording',
                        chatId: VCS.state.chatActiveChatId,
                        phone : VCS.state.chatMyPhone
                    });
                }
            }, 3000);
        }

        VCS.state.chatRecordingTimerInterval = setInterval(() => {
            const elapsed = Date.now() - VCS.state.chatRecordStart;
            const el = $('#chatRecordingTime')[0];
            if (el) {
                el.textContent = VCS.chat?.formatDuration?.(elapsed);
            }
        }, 200);

        VCS.state.chatRecordingLimitTimer = setTimeout(() => {
            if (VCS.state.chatRecording) {
                VCS.chatMessages?.stopRecording?.();
            }
        }, VCS.ChatRecordingUI.CHAT_RECORD_MAX_MS);
    }

    resetRecordingUi() {
        VCS.state.chatRecording = false;
        this.clearHoldTimer();
        this.disarmRecordButton();
        $('#chatMicBtn')[0]?.classList.remove('chat-mic-btn--recording');
        $('#chatRecordingBar')[0]?.classList.add('hidden');
        this.clearRecordTimers();
        this.updateRecordButtonUI();
    }

    // ── Init ─────────────────────────────────────────────────

    init() {
        this._popupOutsideHandler = (e) => this.recordPopupOutside(e);

        const chatMicBtn = $('#chatMicBtn')[0];
        chatMicBtn?.addEventListener('pointerdown', () => this.handlePointerDown());
        chatMicBtn?.addEventListener('pointerup', () => this.handlePointerUp());
        chatMicBtn?.addEventListener('pointercancel', () => this.handlePointerUp());
        chatMicBtn?.addEventListener('pointerleave', () => this.handlePointerUp());
        chatMicBtn?.addEventListener('click', () => this.handleClick());

        // RecordMode-Buttons im Popup werden dynamisch beim Erstellen des Popups gebunden (in showRecordPopup)
    }
};
